import { render } from "./App.vue?vue&type=template&id=97600692"
const script = {}

import "./App.vue?vue&type=style&index=0&id=97600692&lang=css"

import exportComponent from "F:\\MingMing\\project\\tinghai-operation-end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__